import { QuestionComponent } from './QuestionComponent'
import { PropsComponent } from 'app/modules/survey/survey-viewer/survey-question/types/props/props.component'
import { Matrix } from 'app/models/questions/Matrix'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'

export class Props extends Matrix {
  getDisplayComponent() {
    return new QuestionComponent(PropsComponent, this)
  }

  fillFormWithDummyAnswer(surveyForm) {
    this.rowKeys.forEach(rKey => {
      this.statementKeys.forEach(sKey => {
        surveyForm.get(this.key).get(rKey).get(this.commentsControlName).get(sKey).setValue(this.generateLoremIpsum(), {emitEvent: false})
        surveyForm.get(this.key).get(rKey).get(this.formControlName).get(sKey).setValue(true, {emitEvent: false})
      })
    })
  }

  buildStatementFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({})
    this.statementKeys.forEach(sKey => {
      form.addControl(sKey, new UntypedFormControl(true))
    })
    return form
  }
}
